const {ContactInformationModel} = require('./ContactInformationModel')
const {AddressModel} = require( './AddressModel')

const DefaultTheme = `
body {
    background-color: #303030;
    color: #4edf4e;
}

/** Bread crumb is the top secondary nav like bar **/
/** aka in Quote page Quotes>quote>files **/
.breadcrumb {
    background-color: #888888;
}
.breadcrumb-item.active {
    color: white;
}
.breadcrumb {
    border-radius: 1.5rem;
}

.form-label,
.table>:not(caption)>*>* {
    color: #4edf4e; /** Color for text **/
}
tbody tr:nth-child(2n) {
    background: #80808050; /** Color for every other row in a table **/
}

/** id for addon box to view all addons in quote page **/
.subtables,
.DropDownTextField {
    background-color: #4a4a4a !important;
}

/** All drop downs **/
.dropdown-menu {
    background-color: #4a4a4a;
}
/** All drop items **/
.dropdown-item {
    color: #cecece;
}


/** For highlighting active rows **/
tr:not(.subtables):active,
tr:not(.subtables):focus-within {
    background-color: #4edf4e !important;
    color: white !important;
}
tr:not(.subtables):active>td>label,
tr:not(.subtables):focus-within>td>label,
tr:not(.subtables):active>td>label>a,
tr:not(.subtables):focus-within>td>label>a,
tr:not(.subtables):active>td>a,
tr:not(.subtables):focus-within>td>a{
    color: white !important;
}

/** Checkboxes **/
.form-check-input {
    background-color: black !important;
    border-color: black !important;
    color: #4edf4e;
}
.form-check-input:checked {
    background-color: #4edf4e !important;
    border-color: #2ebf2e !important;
    color: black;
}

/** Primary Color for links an other clickable text **/
a, svg, path
{
    color: #4edf4e !important;
    fill: currentcolor !important;
}
a:hover {
    color: #2ebf2e;
}

/** May want to do specific based on each button **/
button.btn.btn-primary,
button.btn.btn-primary:hover,
button.btn.btn-secondary,
button.btn.btn-secondary:hover,
button.btn.btn-success,
button.btn.btn-success:hover,
button.btn.btn-danger,
button.btn.btn-danger:hover,
button.btn.btn-info,
button.btn.btn-info:hover,
button.btn.btn-copy,
button.btn.btn-copy:hover {
    background-color: #000000;
    color: #4edf4e;
    border-color: #00000000;
}

/** Bottom Quote Row aka Save, PDF, Email **/
.quote-bottom-bottons-row {
    position: initial;
}

/** Input fields **/
input.form-control {
    color: #FFFFFF;
    background-color: #404040;
    border-color: #A0A0A0;
}
input.form-control:focus {
    color: #FFFFFF;
    background-color: #404040;
    border-color: #FFFFFF;
}
input.form-control:hover {
    color: #FFFFFF;
    background-color: #404040;
    border-color: #FFFFFF;
}
textarea.form-control,
textarea {
    color: #FFFFFF;
    background-color: #404040;
    border-color: #A0A0A0;
}
textarea.form-control:focus,
textarea:focus {
    color: #FFFFFF;
    background-color: #404040;
    border-color: #FFFFFF;
}
textarea.form-control:hover,
textarea:hover {
    color: #FFFFFF;
    background-color: #404040;
    border-color: #FFFFFF;
}

/* Pop Over Window */
.outermodal > div {
    background-color: #343434;
}

/* Calendar */

.react-calendar {
  background: #343434;
  color: white;
}

.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  color: white;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #e6e6e6;
}
.react-calendar__month-view__days__day {
  color: white;
}
.react-calendar__navigation button[disabled] {
  background-color: #f0f0f0;
}
.react-calendar__month-view__days__day--weekend {
  color: #4edf4e;
}
.react-calendar__month-view__days__day--neighboringMonth {
  color: #cecece;
}

.react-calendar__navigation button[disabled] {
    background-color: #4edf4e;
}

react-calendar__tile {
    color: white;
}
.react-calendar__tile:disabled {
  background-color: #4edf4e;
}
.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: #4edf4e;
}
.react-calendar__tile--now {
  background-color: #4edf4e;
}
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background-color: #4edf4e;
}
.react-calendar__tile--hasActive {
  background: #4edf4e;
}
.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #4edf4e;
}
.react-calendar__tile--active {
  background-color: #4edf4e;
  color: white;
}
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background-color: #4edf4e;
}
.react-calendar--selectRange .react-calendar__tile--hover {
  background-color: #e6e6e6;
}
.react-calendar__navigation__label__labelText--from {
   color: white;
}
.react-calendar__navigation > button {
    color: white;
}

.react-calendar__century-view__decades__decade {
    color: white;
}

.react-calendar__tile {
    border-radius: 999px;
}
`

const Roles = {
    'None': 0,
    'Customer': 1<<0,
    'Asante': 1<<1,
    'Admin': 1<<2,
    'PM': 1<<3,
    'Quoter': 1<<4,
    'Machine': 1<<5,
    'SelectQuery': 1<<6,
    'AsanteAdmin': 1<<7,
}
Object.freeze(Roles)

const Permissions = {
    'None': 0,
}
Object.freeze(Permissions)

/**
 * @param {string} token
 * @return {any}
 */
function parseJwt(token) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(atob(base64)
        .split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))

    return JSON.parse(jsonPayload)
};

/**
 * ThemeItem
 */
class ThemeItem {
    /**
     * @param {string} name
     * @param {string} startTime
     * @param {string} endTime
     */
    constructor(
        name='',
        startTime='00:00',
        endTime='23:59',
    ) {
        this.name = name
        this.start_time = startTime
        this.end_time = endTime
    }

    /**
     * @param {any} json
     * @return {ThemeItem}
     */
    static from(json) {
        const item = Object.assign(new ThemeItem(), json)
        return item
    }

    /**
     * @param {Date} time
     * @return {boolean}
     */
    shouldShowTheme(time) {
        /**
         * @param {string} stringTime
         *      formatted [0-9]{2}:[0-9]{2}
         * @return {number} hour * 60 + minute
         */
        function getTime(stringTime) {
            const t = stringTime.split(':')
            const hour = Number.parseInt(t[0])
            const minute = Number.parseInt(t[1])
            return hour * 60 + minute
        }
        const currentTime = time.getHours() * 60 + time.getMinutes()
        const startTime = getTime(this.start_time)
        const endTime = getTime(this.end_time)
        return startTime <= currentTime && currentTime <= endTime
    }
}

/**
 * Consist of a theme and a name
 */
class Theme {
    /**
     * @param {string} name
     * @param {string} body
     */
    constructor(name='', body=DefaultTheme) {
        this.name = name
        this.body = body
    }

    /**
     * @param {any} json
     * @return {Theme}
     */
    static from(json) {
        const t = Object.assign(new Theme(), json)
        return t
    }
}

/**
 * It used to manage your settings themes
 */
class ThemeSettings {
    /**
     * @param {boolean} isSelected
     * @param {[Theme]} themes
     * @param {[ThemeItem]} items
     */
    constructor(isSelected=false, themes=[], items=[]) {
        this.is_selected = isSelected
        this.themes = themes
        this.items = items
    }

    /**
     * @param {any} json
     * @return {Settings}
     */
    static from(json) {
        const settings = Object.assign(new ThemeSettings(), json)
        for (let i = 0; i < settings.items.length; i++) {
            settings.items[i] = ThemeItem.from(settings.items[i])
        }
        for (let i = 0; i < settings.themes.length; i++) {
            settings.themes[i] = Theme.from(settings.themes[i])
        }
        return settings
    }

    /**
     * @param {string} name
     * @return {string} or null if found none
     */
    getCustomTheme(name) {
        for (let i = 0; i < this.themes.length; i++) {
            if (this.themes[i].name === name) {
                return this.themes[i].body
            }
        }
        return null
    }

    /**
     * @param {Date} now defaults to the real clock; the settings page passes
     *     a simulated hour to preview a time-scheduled theme.
     * @return {[{is_custom: boolean, value: string}]} current themes
     */
    getThemeNames(now = new Date()) {
        const themes = []
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].shouldShowTheme(now)) {
                const theme = this.getCustomTheme(this.items[i].name)
                if (theme !== null) {
                    themes.push({
                        'is_custom': true,
                        'value': theme,
                    })
                } else {
                    themes.push({
                        'is_custom': false,
                        'value': this.items[i].name,
                    })
                }
            }
        }

        return themes
    }

    /**
     * This will append a default theme
     */
    addTheme() {
        this.themes.push(new Theme())
    }

    /**
     * This will append a default theme time item
     * @param {string} name
     */
    addTimeItem(name='') {
        this.items.push(new ThemeItem(name))
    }
}

/**
 * Model for Settings
 */
class Settings {
    /**
     * @param {boolean} excelArrowKeys
     * @param {boolean} numbersCalculatorShow
     * @param {boolean} autoTypeSignType
     * @param {boolean} importExportSignJson
     * @param {string} quoteNumberPrefix
     * @param {ContactInformationModel} asanteContactInfo
     * @param {ContactInformationModel} contactInfo
     * @param {ShippingInfo} shippingInfo
     * @param {boolean} signEditingTop
     * @param {ThemeSettings} themeSettings
     */
    constructor(
        excelArrowKeys=false,
        numbersCalculatorShow=false,
        autoTypeSignType=true,
        importExportSignJson=false,
        quoteNumberPrefix=null,
        asanteContactInfo=ContactInformationModel.fromAsante({}),
        contactInfo=new ContactInformationModel(),
        shippingInfo=new AddressModel(),
        signEditingTop=false,
        themeSettings=new ThemeSettings(),
    ) {
        this.excel_arrow_keys = excelArrowKeys
        this.numbers_calculator_show = numbersCalculatorShow
        this.auto_type_sign_type = autoTypeSignType
        this.import_export_sign_json = importExportSignJson
        this.quote_number_prefix = quoteNumberPrefix
        this.asante_contact_info = asanteContactInfo
        this.contact_info = contactInfo
        this.shipping_info = shippingInfo
        this.sign_editing_top = signEditingTop
        this.theme_settings = themeSettings
    }

    /**
     * @param {any} json
     * @return {Settings}
     */
    static from(json) {
        const settings = Object.assign(new Settings(), json)
        settings.theme_settings = ThemeSettings.from(settings.theme_settings)
        if (settings.quote_number_prefix == null) {
            settings.quote_number_prefix =
                settings.contact_info.first_name.substr(0, 3).toUpperCase()
        }

        return settings
    }

    /**
     * Gets the settings from the cookie
     * @return {Settings}
     */
    static fromLocalStorage() {
        const account = Account.fromLocalStorage()
        return Settings.from(account.settings)
    }

    /**
     * Saves to local storage
     */
    saveToLocalStorage() {
        const account = Account.from(Account.fromLocalStorage())
        account.settings = this
        account.saveToLocalStorage()
    }
}

/**
 * Model for Account
 * Could change it so it has two variables
 *      (local storage object, cookie object)
 */
class Account {
    /**
     * @param {string} email
     * @param {string} password
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} company
     * @param {boolean} verified
     * @param {Settings} settings
     * @param {number} role
     * @param {number} permissions
     */
    constructor(email='', password='',
        firstName='', lastName='', company='', verified=false,
        settings=new Settings(), role=0, permissions=0) {
        this.email = email // cookie
        this.password = password // neither; maybe cookie to relogin
        this.first_name = firstName // local storage
        this.last_name = lastName // local storage
        this.company = company // cookie
        this.verified = verified // cookie
        this.settings = settings // local storage
        this.role = role // cookie
        this.permissions = permissions // cookie
    }

    /**
     * @param {any} json
     * @return {Account}
     */
    static from(json) {
        const account = Object.assign(new Account(), json)
        account.settings = Settings.from(account.settings)
        return account
    }

    /**
     * @return {object} local storage part of account
     */
    static fromLocalStorage() {
        const item = JSON.parse(localStorage.getItem('account'))
        const obj = Object.assign({
            'first_name': '',
            'last_name': '',
            'settings': new Settings(),
        }, item)
        obj.settings = Settings.from(obj.settings)
        return obj
    }

    /**
     * Gets the account from the cookie
     * @return {Account}
     */
    static fromCookie() {
        try {
            const cookie = document.cookie.split(';')
                .filter((x) => {
                    return x.split('=')[0].trim() === 'token'
                })

            if (cookie.length === 0) {
                return null
            }

            const jwt =
                cookie[0].split('=')[1]

            const parseObject = parseJwt(jwt)
            if (new Date(parseObject.exp * 1000) < new Date()) {
                return null
            }

            return Account.from(parseObject.data)
        } catch (e) {
            return null
        }
    }

    /**
     * Gives you an account from cookie and local storage
     * @return {Account}
     */
    static fromCookieAndLocalStorage() {
        const cookie = Account.fromCookie()
        if (cookie === null) return null
        const localS = Account.fromLocalStorage()
        if (localS === null) return null
        return Account.from(Object.assign(cookie, localS))
    }

    /**
     * Strips variables but things that go into cookie
     * @param {json} json
     * @return {json}
     */
    static stripEverythingButCookie(json) {
        return (({
            id,
            email,
            // password,
            company,
            verified,
            role,
            permissions,
        }) => ({
            id,
            email,
            // password,
            company,
            verified,
            role,
            permissions,
        }))(json)
    }

    /**
     * Saves local storage variables to local storage
     */
    saveToLocalStorage() {
        localStorage.setItem('account', JSON.stringify({
            'first_name': this.first_name,
            'last_name': this.last_name,
            'settings': this.settings,
        }))
    }

    // MARK: Role

    /**
     * Adds role
     * @param {number} role
     */
    addRole(role) {
        this.role |= role
    }

    /**
     * Removes role
     * @param {number} role
     */
    removeRole(role) {
        this.role = (this.role | role) ^
            role
    }

    /**
     * @param {number} role
     * @return {boolean}
     */
    hasRole(role) {
        return (this.role & role) === role
    }


    // MARK: Permissions

    /**
     * Adds permission
     * @param {number} permission
     */
    addPermission(permission) {
        this.permissions |= permission
    }

    /**
     * Removes permission
     * @param {number} permission
     */
    removePermission(permission) {
        this.permissions = (this.permissions | permission) ^
            permission
    }

    /**
     * @param {number} permission
     * @return {boolean}
     */
    hasPermission(permission) {
        return (this.permissions & permission) === permission
    }

    /**
     * @return {boolean} false iff user is asante user
     */
    isCustomer() {
        return !this.hasRole(Roles.Asante)
    }
}


module.exports = {
    Account,
    Settings,
    Roles,
    Permissions,
}
